import {numericality} from 'redux-form-validators';

export default opts =>
  numericality({
    ...opts
  });



// WEBPACK FOOTER //
// ./validators/units/numericality.js